import React from "react"
import {Box, Grid, Typography} from "@mui/material"

import AnalyzerTableShowDataHeaderCell from "./HeaderCell"
import { openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import {reports, searchID} from "../../../../@signals";
import {AppOfficesBlock} from "../../../../@components";


export default function AnalyzerEvolutionHeader({ isRating }) {
	const { tableRows } = openEvolutionModal.value

	return <>
		<Box sx={{ maxHeight: 150, overflowY: 'auto' }}>
			{tableRows?.map((rowData, index) => {
				if (!isRating || (isRating && index === 0)) {
					return <CellAnalyzerEvolutionHeader key={index} idx={index} dataRow={rowData} isRating={isRating} />
				}
				return null
			})}
		</Box>
	</>
}

function CellAnalyzerEvolutionHeader({ dataRow, isRating, idx }) {
	const {
		id_master_provider_translation, price, automatic_translation, id_category, length_of_rental,
		unlimited_km_translation, included_km, in_terminal_pickup_translation, id_fuel_policy_translation,
		is_prepaid_translation, pickup_date_translation, acriss_code, id_site_translation, color
	} = dataRow

	const dataCells = [
		{ condition: (!isRating && !!id_site_translation) || (isRating && idx === 0), dataName: "Site", dataToShow: id_site_translation, color },
		{ condition: !!price, dataName: "Price", dataToShow: price },
		{ condition: !isRating && !!id_master_provider_translation, dataName: "Provider", dataToShow: id_master_provider_translation },
		{ condition: !!id_category, dataName: "Category", dataToShow: id_category },
		{ condition: !!acriss_code, dataName: "Acriss", dataToShow: acriss_code },
		{ condition: !!unlimited_km_translation, dataName: "Mileage", dataToShow: unlimited_km_translation },
		{ condition: included_km !== null && included_km !== undefined, dataName: "Limited included", dataToShow: `${included_km} Km` },
		{ condition: !!automatic_translation, dataName: "Transmission", dataToShow: automatic_translation },
		{ condition: !!id_fuel_policy_translation, dataName: "Fuel Policy", dataToShow: id_fuel_policy_translation },
		{ condition: !!in_terminal_pickup_translation, dataName: "In Terminal", dataToShow: in_terminal_pickup_translation },
		{ condition: !!is_prepaid_translation, dataName: "Payment Option", dataToShow: is_prepaid_translation },
		{ condition: !!pickup_date_translation, dataName: "Pickup Date", dataToShow: pickup_date_translation },
		{ condition: !!length_of_rental, dataName: "Lor", dataToShow: length_of_rental }
	]

	return (
		<Grid container spacing={2} key={`${idx}-${color}`}>
			<Grid item xs={12}>
				<Box sx={{ display: 'flex', justifyContent: "space-between", py: 1 }}>
					{dataCells.map(({ condition, dataName, dataToShow, color }) => (
						condition && <AnalyzerTableShowDataHeaderCell key={dataName} dataName={dataName} dataToShow={dataToShow} color={color}/>
					))}
				</Box>
			</Grid>
		</Grid>
	)
}
